module.exports = __webpack_public_path__ + "static/media/section3_img1.cecc9910.png";